import { isNull, template, compiled } from 'lodash'
import flickity from 'flickity'
import 'flickity-imagesloaded'
import Testimonials from '../components/Testimonials'
import axios from 'axios'

export default class About {
    constructor() {
        this.cacheDom()
        this.initialize()
        this.bindEvents()
    }

    cacheDom() {
        this.flkty = null
        this.data = []
        this.slider = document.querySelector('.content-slider-wrap')
        this.loadMore = document.querySelector('.load-more-trigger')
        this.currentSlide = document.querySelector('.content-slider-controls .tagline-alt span')
        this.nextArrow = document.querySelector('.content-slider-controls-next')
        this.prevArrow = document.querySelector('.content-slider-controls-prev')

        this.template = document.getElementById('instagram-template')
        this.container = document.getElementById('instagram-feed-container')
    }

    resize() {
        const breakpoint = window.matchMedia('(min-width: 1025px)')

        if (breakpoint.matches) {
            this.render(this.data)
        } else {
            this.render(this.data.slice(0, 4))
        }

        this.loadMore.classList.remove('is-hidden')
    }

    initialize() {
        this.flkty = new flickity(this.slider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            lazyLoad: true,
            on: {
                change: (index) => {
                    const sum = index + 1
                    this.currentSlide.innerHTML = sum >= 10 ? sum : `0${sum}`
                },
            },
        })

        new Testimonials()
        this.fetchInstagram()
    }

    bindEvents() {
        if (!isNull(this.flkty)) {
            this.nextArrow.addEventListener('click', () => {
                this.flkty.next()
            })

            this.prevArrow.addEventListener('click', () => {
                this.flkty.previous()
            })
        }

        if (!isNull(this.loadMore)) {
            this.loadMore.addEventListener('click', (event) => {
                event.preventDefault()
                this.render(this.data.slice(4), true)
                event.target.classList.add('is-hidden')
            })
        }
    }

    fetchInstagram() {
        axios.get('https://api.timbashield.strafe.dev/api/v1/instagram/feed').then((response) => {
            this.data = response.data
            this.resize()
        })
    }

    render(data, append = false) {
        const compiled = template(this.template.textContent)
        const result = compiled({ items: data })

        if (append) {
            this.container.insertAdjacentHTML('beforeend', result)
        } else {
            this.container.innerHTML = result
        }
    }
}
